module.exports = __webpack_public_path__ + "static/media/monkey.454a77f4.svg";